import { useHistory } from "react-router-dom";

// `history.length` reflects the real browser/WebView navigation stack size —
// 1 means this is the only entry (deep link, new tab, notification), so
// there's no in-app page to go back to and we navigate to the fallback
// instead. This is more reliable across environments than `location.key`,
// which some WebViews set even on the very first entry.
export const useGoBack = (fallbackPath: string): (() => void) => {
  const history = useHistory();

  const goBack = () => {
    if (history.length > 1) {
      history.goBack();
      return;
    }

    history.replace(fallbackPath);
  };

  return goBack;
};
